import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Confirm from './components/Confirm';

const root = ReactDOM.createRoot(document.getElementById('contact-form-bottom'));
const topRoot = ReactDOM.createRoot(document.getElementById('contact-form-top'));

root.render(
  <React.StrictMode>
    <Confirm />
  </React.StrictMode>
);

topRoot.render(
  <React.StrictMode>
    <Confirm />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
